import {queryOptions, type UseQueryOptions} from '@tanstack/react-query';
import {SHORTCUT_QUERY_KEY_MAP} from '../api/shortcut/constant';
import {getShortcutList} from '../api/shortcut/getShortcutList';
import type {FetcherOptions} from '../axios/axiosBffFetch';
import {PagewebError} from '../errors/PagewebError.class';
import {createSimpleApiResponseError} from '../graphql/api/createSimpleApiResponseError';
import {createShortcutList} from '../graphql/factory/ShortcutList';
import type {
  ShortcutListQuery,
  ShortcutListQueryVariables,
} from '../graphql/generated/types';

/**
 * Shortcut 도메인 Query Factory
 *
 * Adapter layer를 제거하고 Factory에서 직접 데이터 변환을 수행
 */
export const shortcutFactory = {
  /**
   * 바로가기 목록 조회
   */
  shortcutList: (
    variables?: ShortcutListQueryVariables,
    options?: Omit<
      UseQueryOptions<ShortcutListQuery, PagewebError, ShortcutListQuery>,
      'queryKey' | 'queryFn'
    >,
    fetcherOptions?: FetcherOptions
  ) =>
    queryOptions({
      queryKey: SHORTCUT_QUERY_KEY_MAP.shortcutList(variables),
      queryFn: async () => {
        const response = await getShortcutList(fetcherOptions);

        if (!response.result) {
          throw createSimpleApiResponseError(
            '바로가기 결과를 받아오지 못했습니다'
          );
        }

        // Adapter의 combine 로직을 여기서 수행
        return {
          shortcutList: createShortcutList(response.result),
        };
      },
      ...options,
    }),
} as const;
